import isString from 'lodash/isString';
import startsWith from 'lodash/startsWith';

export const isAutopayNumber = (value: unknown): value is string =>
  isString(value) &&
  startsWith(value, 'AP') &&
  value.length > 2 &&
  /^\d+$/.test(value.slice(2));
